"use client";

import { useEffect } from 'react';
import { useFirebaseNotifications } from '@/hooks/useFirebaseNotifications';

export default function NotificationManager() {
  const { saveTokenManually } = useFirebaseNotifications();
  
  useEffect(() => {
    const checkAuthAndSaveToken = () => {
      const authToken = localStorage.getItem('token');
      if (authToken) {
        saveTokenManually();
      }
    };
    
    checkAuthAndSaveToken();
    
    const handleStorageChange = (e) => {
      if (e.key === 'token' && e.newValue) {
        setTimeout(() => saveTokenManually(), 1000);
      }
    };
    
    window.addEventListener('storage', handleStorageChange);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [saveTokenManually]);
  
  return null;
}